<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
      >
        Mostrar desglosado
      </v-btn>
    </template> 
  <v-card elevation="1" style="padding: 20px 0;">
    <v-toolbar
          dark
          color="primary"
          elevation="0"
          style="border-radius: 0;"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ $t('dashboard.stats.accessMenu')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-select
            v-model="selectedDateFilter"
            :items="datesFilter"
            :label="$t('dashboard.stats.month')"
            item-text="Name"
            item-value="ID"
            hide-details
            dense
            solo
            style="max-width:250px;margin-right: 10px;"
          />
          <v-select
            v-if="sources && sources.length > 0"
            v-model="selectedSource"
            :items="sources"
            label="Identificador"
            item-text="Name"
            item-value="ID"
            hide-details
            dense
            solo
            style="max-width:250px;"
            @change="handleGetStats" 
          />
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
            {{ $t('common.close', locale)}}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
    <div class="table-stats" style="padding-top: 20px;">
      <div
        v-if="loading"
        style="padding: 0 0 15px 0"
      >
        <v-progress-linear
          indeterminate
          :color="enterpriseColor"
        />
        <center>
          <small :style="{ color: enterpriseColor}">{{info}}</small>
        </center>
      </div>
      <div style="padding: 0 10px;">
        </div>
        <v-simple-table v-if="menus">
        <thead>
          <tr>
            <th class="text-left" style="font-weight:300;">{{ $t('dashboard.stats.menu') }}</th>
            <th 
              v-for="item of days"
              :key="`h-${item}`"
              class="text-center" 
              style="font-weight:300"
            >
              {{item}}
            </th>
            <th class="text-center" style="font-weight:300">T</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in menus" :key="item.ID" style="padding-top:5px;">
            <td class="text-left">{{ item.Name }}</td>
            <td 
              v-for="d of days"
              :key="`d-${d}`"
              class="text-center"
              :style="{ color: item[d] ? 'black' : '#CCCCCC80' }"
            >
              {{ loading ? '...' : item[d] }}
            </td>
            <td 
              class="text-center"
              :style="{ color: item.Clicks ? 'black' : '#CCCCCC80' }"
            >
              <b>{{ loading ? '...' : item.Clicks }}</b>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div style="padding-right: 20px;">
        <click-export 
          v-if="dataToExcel"
          :data="dataToExcel"
        />
      </div>
    </div>
  </v-card>
  </v-dialog>
</template>
<script>
  import axios from 'axios'
  import i18n from '@/plugins/i18n'
  import _ from 'lodash'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import ClickExport from './ClickExport'
  export default {
    components: {
      ClickExport,
    },
    props: {
      workspaceID: {
        type: String,
        required: true
      },
      sources: {
        type: Array,
        default: null,
      },
    },
    data: () => ({
      dialog: false,
      loading: false,
      menus: null,
      stats: null,
      today: new Date(),
      key: 0,
      dates: null,
      dataToExcel: null,
      datesFilter: [],
      selectedDateFilter: null,
      info: null,
      days: null,
      selectedSource: null,
    }),
    computed: {
      locale () {
        return i18n.locale
      },
      enterpriseColor() {
        return this.$store.state.app.enterpriseColor
      },
    },
    watch: {
      workspaceID () {
        this.handleGetMenus()
      },
      selectedDateFilter (v) {
        if (!v) return
        this.handleGetStats()
      },
      dialog () {
        if (this.dialog) {
          this.handleGetMenus()
        }
      },
      sources () {
        this.selectedSources = null
      },
    },
    mounted () {
      this.prepareSelect() 
      this.handleGetMenus()
    },
    methods: {
      getLastDay (m) {
        const aux = new Date(2008, m, 0)
        return aux.getDate()
      },
      prepareMonth  () {

      },
      prepareSelect () {
        //const result = [{ ID: { year: null, month: null }, Name: 'Todos' }]
        const result = []
        let i = 0
        let today = new Date()
        let year = today.getFullYear()
        while (i < 1000 && year >= 2019) {
          today = new Date()
          const newDate = new Date(today.setMonth(today.getMonth() -i))
          year = newDate.getFullYear()
          let month = newDate.getMonth() + 1
          result.push({ ID: { year, month}, Name: `${year} / ${month}` })
          i++
        }
        this.datesFilter = result
        this.selectedDateFilter = this.datesFilter[0].ID
        this.days = []
        for (let i = 1; i <= this.getLastDay(this.selectedDateFilter.month); i++) {
          this.days.push(i)
        }
      },
      getTranslation(v, locale) {
        return utils.getTranslation(v, locale)
      },
      handleGetMenus () {
        if (!this.dialog) return
        api.getAll(`workspaces/${this.workspaceID}/menus`, 1, 10000)
          .then(response => {
            const results = []
            const aux = response.filter(x => x.Name).map(item => {
              return {
                ID: item.ID,
                Name: item.Name ? utils.getTranslation(JSON.parse(item.Name), this.locale) : null,
                ORD: item.ORDPrimary,
                ParentID: item.ParentID,
              }
            })
            for (const item of aux.filter(x => !x.ParentID).sort((a, b) => { return parseInt(a.ORD) - parseInt(b.ORD)})) {
              results.push(item)
              results.push(
                ...aux.filter(x => x.ParentID === item.ID).map(i => {
                 i.Name = `${item.Name} / ${i.Name}`
                    return i
                }).sort((a, b) => { return parseInt(a.ORD) - parseInt(b.ORD)})
              )
              
            }
            this.menus = results
            this.handleGetStats()
          })
          .catch(error => {
            console.log(error)
          })
      },
      async handleGetStats () {
        this.info = null
        const baseURL = 'https://cm-dtouch-stats-api.dtouch.es'
        //const baseURL = 'http://localhost:3805'
        if (!this.selectedDateFilter || !this.menus) return

        this.menus = this.menus.map(item => {
          item.Clicks = '...'
          return item
        })

        const { year, month } = this.selectedDateFilter

                this.days = []
        for (let i = 1; i <= this.getLastDay(this.selectedDateFilter.month); i++) {
          this.days.push(i)
        }


          this.loading = true
          const url = `${baseURL}/v1/public/stats/menu-count-group-days/m/${this.workspaceID}/${year}/${month}/${this.selectedSource ? this.selectedSource : ''}`
          axios.get(url)
            .then(response => {
            this.menus = this.menus.map(item => {
              let count = 0
              for (let day of this.days) {
                let clicks = response.data.filter(x => x.MenuID === item.ID && x.Day===day).map(item => item.Clicks).shift()
                clicks = clicks ? clicks : 0
                item[day] = clicks
                count += clicks
              }
              item.Clicks = count
              return item
            })

              /*
                this.dataToExcel = this.menus.map(item => {
                  return {
                    MENUS: item.Name,
                    CLICKS: item.Clicks,
                  }
                })
*/
              this.loading = false
            })
            .catch(error => {
              console.log(error)
            })
      },
    }
  }
</script>
<style>
  .table-stats td {
    vertical-align: middle !important;
  }
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>
